type ProgressBarProps = {
  height?: string;
  percentage: string;
};

const ProgressBar = ({ height = '4px', percentage }: ProgressBarProps) => {
  return (
    <div
      role="progressbar"
      aria-valuenow={parseInt(percentage)}
      aria-valuemin={0}
      aria-valuemax={100}
      className="w-full bg-primary/10 rounded-full my-1"
      style={{ height: height }}
    >
      <div className="bg-primary rounded-full" style={{ height: height, width: percentage }} />
    </div>
  );
};

export default ProgressBar;
